import { useEffect, useRef } from 'react';

interface NetworkToastOptions {
  onOffline?: () => void;
  onOnline?: () => void;
}

export function useNetworkStatus({ onOffline, onOnline }: NetworkToastOptions = {}) {
  const isMounted = useRef(false);

  useEffect(() => {
    const handleOffline = () => {
      if (isMounted.current) onOffline?.();
    };

    const handleOnline = () => {
      if (isMounted.current) onOnline?.();
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    isMounted.current = true;

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, [onOffline, onOnline]);
}
